<template>
  <v-container fluid>
    <v-row align="center" no-gutters>
      <v-col cols="12" style="position: relative" class="pb-0">
        <v-row>
          <v-col class="pb-0 d-flex flex-row align-center">
            <div>
              <h3>{{fullName}}</h3>
              <small>{{fullNameKana}}</small>
            </div>
            <div class="ml-12">
              <CompetitionMedals
                  :gold="candidateUser.competition.medals.gold"
                  :silver="candidateUser.competition.medals.silver"
                  :bronze="candidateUser.competition.medals.bronze"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" style="position: relative">
        <ProfileDetails
            :user="candidateUser"
            :consts="consts"
            :isSide="isSide"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import ProfileDetails from "@/components/organisms/ProfileDetails";
import ApiMixin from "@/ApiMixin";
import CompetitionMedals from "@/components/molecules/CompetitionMedals";

export default {
  components: {CompetitionMedals, ProfileDetails},
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "CandidateResumeDialog",
  props: {
    isSide: {
      type: Boolean,
    },
    candidateUser: undefined,
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    fullName() {
      if(this.candidateUser.detail) {
        const lastName = this.candidateUser.detail.lastName || ""
        const firstName = this.candidateUser.detail.firstName || ""
        return lastName + " " + firstName;
      }
      return ""
    },
    fullNameKana() {
      if(this.candidateUser.detail) {
        const lastNameKana = this.candidateUser.detail.lastNameKana || ""
        const firstNameKana = this.candidateUser.detail.firstNameKana || ""
        return lastNameKana + " " + firstNameKana;
      }
      return ""
    },
  },
  methods: {},
  watch: {}
}
</script>

<style scoped>

</style>
